export enum ScrollModeEnum {
  // capture scroll away from parent window.  i.e. scrolljack
  Capture = 'capture',
  
  // only capture when CTRL is pressed. Present a message if user scrolls without pressing CTRL.
  DoNotCaptureShowMessage = 'do_not_capture_show_message', 

  // only capture when CTRL is pressed
  DoNotCapture = 'do_not_capture' 
}
